import { useContainer } from '../../useContainer';
import { ContactApi, ToastStateHandler } from '../../../api';
import { CreateContactDto } from '../../../commonTypes/client.types';
import { dispatch } from '../../../store';
import { addContact } from '../../../store/slices/clients.slice';
import { useTranslation } from '../../useTranslation';

const useHttpPostContact = () => {
    const { t } = useTranslation('newNotifications');
    const contactApi: ContactApi = useContainer(ContactApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (clientId: string, body: CreateContactDto) => {
        const { exec, abort } = contactApi.create({
            params: { clientId },
            body,
            onSuccess: response => {
                dispatch(addContact({ clientId, contact: response.body }));
                return toastHandler.push('success', t('contact.createContactTitle'), t('contact.createContactMessage_Success'));
            },
            onError: _ => toastHandler.push('error', t('contact.createContactTitle'), t('contact.createContactMessage_Failed')),
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostContact;
